import { Flex, Heading, IconButton, Text } from "@chakra-ui/react";
import { Filters, MenuItem } from "components/listing";
import { filterPizzas, filterSentence } from "misc/filter";
import { IFilter, IPizza } from "misc/interfaces";
import React, { FC, useEffect, useMemo, useState } from "react";

import { useIntlFormat } from "hooks/useIntlFormat";
import { useAppDataContext } from "misc/appDataCtxt";
import { AppDataActions } from "misc/enums";
import { FiArrowLeft } from "react-icons/fi";

interface Props {
  onOpen: () => void;
  pizzas: Array<IPizza>;
  filters: IFilter;
}

export const MenuFiltered: FC<Props> = ({ onOpen, pizzas, filters }) => {
  const [intlFormatter] = useIntlFormat();
  const [listOfMatchingPizzas, setListOfMatchingPizzas] =
    useState<Array<IPizza>>(pizzas);
  const [sentence, setSentence] = useState("");
  const { dispatch } = useAppDataContext();

  useEffect(
    () => setListOfMatchingPizzas(filterPizzas(pizzas, filters)),
    [filters, pizzas]
  );
  useMemo(() => setSentence(filterSentence(filters)), [filters]);

  return (
    <>
      <Flex
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Heading as="h1" size="xl" my={4}>
          Votre sélection de {listOfMatchingPizzas?.length} pizzas
        </Heading>
        <IconButton
          aria-label="Close pizza"
          icon={<FiArrowLeft />}
          variant="outline"
          bgColor={"white"}
          onClick={() =>
            dispatch({
              type: AppDataActions.resetAllFilters,
            })
          }
        />
      </Flex>

      <Flex wrap={"wrap"} justifyContent={"space-between"}>
        <Text my={4}>{sentence}</Text>
        <Filters openDrawer={onOpen} />

        {listOfMatchingPizzas?.map((pizza) => (
          <MenuItem
            key={pizza.id}
            id={pizza.id}
            image={pizza.photos[0].url}
            name={pizza.name}
            alt={pizza.name}
            detail={intlFormatter?.format(pizza.ingredients)}
            price={pizza.prices[0]}
            url={`/pizza/${pizza.slug}`}
          />
        ))}
      </Flex>
    </>
  );
};
